import { HotspotStatus, HotspotWithLabel } from "@nova/constants"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    selectHotspotWithLabelById,
    selectRemovedHotspots,
} from "features/entity-caching/hotspots/selectors"
import { IconLayer } from "@deck.gl/layers"
import { selectHotspotPanelItems } from "panels/hotspot/selectors"
import { setHotspotPanelState } from "panels/hotspot/slice"
import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"
import { selectSnapshotOpen } from "plugins/PDFv2/PDFSlice"

export const useDeletedHotspotsLayer = () => {
    const dispatch = useAppDispatch()
    const selectedHotspotId = useAppSelector(selectHotspotPanelItems).hotspotId

    const hotspots = useAppSelector(selectRemovedHotspots)

    const selectedHotspot = useAppSelector(selectHotspotWithLabelById(selectedHotspotId))

    const isRemovedHotspot = selectedHotspot?.status === HotspotStatus.Removed

    const handleRemovedHotspotClick = (hotspot: HotspotWithLabel) => {
        dispatch(
            setHotspotPanelState({
                hotspotId: hotspot.id,
                imageId: hotspot.imageId,
                flightId: hotspot.flightId,
            })
        )
    }

    const removedHotspotsLayerData = selectedHotspot
        ? [...hotspots, selectedHotspot].filter((h) => h.status === HotspotStatus.Removed)
        : hotspots

    const snapshotOpen = useAppSelector(selectSnapshotOpen())

    return snapshotOpen
        ? []
        : [
              new IconLayer<HotspotWithLabel>({
                  id: "SelectedRemovedHotspotsIconLayer",
                  visible: isRemovedHotspot,
                  data: [selectedHotspot].filter(Boolean),
                  getIcon: () => ({
                      url: "/icons/shape/svg/PlusWithBorder.svg",
                      width: 512,
                      height: 512,
                  }),
                  billboard: false,
                  getSize: 16,
                  getAngle: 45,
                  getPosition: (hotspot) => [hotspot.longitude, hotspot.latitude],
                  extensions: [...getGlobalTerrainData().extensions],
              }),
              new IconLayer<HotspotWithLabel>({
                  id: "RemovedHotspotsIconLayer",
                  visible: !!removedHotspotsLayerData.length,
                  data: removedHotspotsLayerData,
                  getIcon: () => ({
                      url: "/icons/shape/svg/Plus.svg",
                      width: 512,
                      height: 512,
                      mask: true,
                  }),
                  billboard: false,
                  getColor: () => [255, 0, 0],
                  getSize: 16,
                  getAngle: 45,
                  pickable: true,
                  getPosition: (hotspot) => [hotspot.longitude, hotspot.latitude],
                  onClick: (pickingInfo) =>
                      pickingInfo.object && handleRemovedHotspotClick(pickingInfo.object),
                  extensions: [...getGlobalTerrainData().extensions],
              }),
          ]
}
